import { motion } from "framer-motion";
import { GraduationCap, Globe2, Award, Wifi } from "lucide-react";
import { FLORIDA_COASTAL } from "@/lib/site-data";

const LEVEL_ICONS = [GraduationCap, Award, Globe2];

export default function FloridaCoastal() {
  return (
    <section id="florida-coastal" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-secondary via-secondary to-[hsl(226_50%_25%)] text-white p-8 sm:p-12 md:p-16 shadow-2xl"
          data-testid="florida-coastal-section"
        >
          {/* decorative accent */}
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-brand-red/20 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-primary/25 blur-3xl pointer-events-none" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-6">
              <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-brand-red font-medium bg-white/[0.06] border border-white/10 rounded-full px-3 py-1.5">
                <Wifi size={13} /> {FLORIDA_COASTAL.role}
              </span>
              <h2 className="font-display text-4xl md:text-5xl mt-6 leading-[1.05]">
                Earn a globally-recognised US degree — <span className="text-brand-red italic">100% online</span>.
              </h2>
              <p className="text-white/70 mt-5 leading-relaxed max-w-lg">
                Studyvia is proud to be partnered with <span className="text-white font-medium">{FLORIDA_COASTAL.name}</span>, {FLORIDA_COASTAL.location} — offering their full ladder of online programs to students in India: Bachelor's, Master's and Doctorate. Study from anywhere. Graduate with a US degree.
              </p>
              <div className="flex flex-wrap gap-3 mt-7">
                {["100% Online", "US Accredited", "Flexible Intakes"].map((t) => (
                  <span key={t} className="text-xs uppercase tracking-wider rounded-full border border-white/15 bg-white/[0.05] px-3 py-1.5 text-white/85">{t}</span>
                ))}
              </div>
            </div>

            <div className="lg:col-span-6 grid sm:grid-cols-3 gap-4">
              {FLORIDA_COASTAL.degrees.map((d, i) => {
                const Icon = LEVEL_ICONS[i];
                return (
                  <motion.div
                    key={d.level}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.6, delay: 0.15 + i * 0.08 }}
                    data-testid={`fcu-degree-${i}`}
                    className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 hover:bg-white/[0.07] hover:border-brand-red/50 transition-[background-color,border-color] duration-300"
                  >
                    <Icon size={22} className="text-brand-red mb-3" />
                    <h3 className="font-display text-xl text-white leading-snug">
                      {d.level}
                    </h3>
                    <p className="text-sm text-white/60 mt-2 leading-relaxed">{d.desc}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
